import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as ReactDOM from 'react-dom';
import { Link } from 'react-router';
import { get, isEqual, defaultTo } from 'lodash';
import { ControlledRadioButton as SparkRadioButton } from '../../ui/sabre-spark-react-ex';
import ConfigurationCheckbox from '../../widgets/ConfigurationCheckbox';
import ReactSparkTextInput from '../../widgets/ReactSparkTextInput';
import CollapsePanel from '../../widgets/CollapsePanel/CollapsePanel';
import { getText } from '../../../../lib/utils';
import Message from '../../message/Message';
import If from '../../helpers/if';
import { CRM_SIGN_IN_TYPE } from '../../../constants/crm-sign-in-type';
import ConfigManage from './configurationListSettings/index';
import './GlobalBarConfiguration.scss';

class GlobalBarConfiguration extends Component {
    constructor(props) {
        super(props);
        this.sections = [];
        this.state = {
            sections: []
        };

        this._onUseGhaProviderCheckboxChange = this._onUseGhaProviderCheckboxChange.bind(this);
    }

    componentDidMount() {
        const { onIndex } = this.props;
        if (onIndex) {
            this.sections.forEach((section, key) => {
                onIndex(getText(ReactDOM.findDOMNode(section)), [key]);
            });
        }
    }

    parseBool = value => {
        const lowerCaseValue = value.toLowerCase();
        if (lowerCaseValue === 'true' || lowerCaseValue === 'false') {
            return JSON.parse(value);
        }
        return value;
    };

    handleSignInOption = event => {
        const { setConfigBoolean, setCustomConfigText } = this.props;
        const { name } = event.target;

        switch (name) {
            case 'CRM':
                setConfigBoolean('crm.logInPassCredentials', false);
                setCustomConfigText('crm', 'integrationType', '');
                break;
            case 'BookingEngine':
                setConfigBoolean('crm.logInPassCredentials', true);
                setCustomConfigText('crm', 'integrationType', '');
                break;
            case 'Salesforce':
                setConfigBoolean('crm.logInPassCredentials', false);
                setCustomConfigText('crm', 'integrationType', 'Salesforce');
                break;
            default:
        }
    };

    sectionStyleHandler = key => {
        const { searchIndex } = this.props;
        return searchIndex !== undefined && searchIndex.indexOf(key) === -1 ? { display: 'none' } : {};
    };

    registerSection(key) {
        return node => {
            this.sections[key] = node;
        };
    }

    _onUseGhaProviderCheckboxChange(key, value) {
        const { toggleConfigBoolean, setConfigBoolean } = this.props;

        toggleConfigBoolean(key, value);

        if (value) {
            setConfigBoolean('offerDual', false);
            setConfigBoolean('isGhaBoxChecked', false);
        }
    }

    renderCrmProfileProviderSettings = () => {
        const {
            currentConfigCopy,
            isDisabled,
            setCustomConfigText,
            setConfigBoolean,
            toggleConfigBoolean
        } = this.props;
        const enrollmentFlow = get(currentConfigCopy, 'crm.enrollmentFlow', 'redirect');
        const integrationType = get(currentConfigCopy, 'crm.integrationType', '');
        const logInPassCredentials = get(currentConfigCopy, 'crm.logInPassCredentials', true);
        const isCrmRadioButtonSelected = logInPassCredentials === false || logInPassCredentials === 'false';

        return (
            <div className="indent-left space-bottom-small">
                <div className="indent-left-small">
                    <h5>CRM Sign In</h5>
                    <If condition={integrationType !== 'Salesforce'}>
                        <div className="space-bottom-small">
                            <ReactSparkTextInput
                                label="Enter “Sign In” Form link"
                                isDisabled={isDisabled}
                                value={currentConfigCopy.crm.logInUrl}
                                onChange={event => {
                                    setCustomConfigText('crm', 'logInUrl', event.target.value);
                                }}
                            />
                        </div>
                    </If>
                    <SparkRadioButton
                        name="BookingEngine"
                        value={!isCrmRadioButtonSelected && integrationType === ''}
                        checked={!isCrmRadioButtonSelected && integrationType === ''}
                        onChange={this.handleSignInOption}
                    >
                        Use the Booking Engine "Sign In" form.
                        <br />
                        (Guest will remain on Booking Engine, SBE will pass sign-in credentials, authenticate with CRM,
                        and sign guest in)
                    </SparkRadioButton>
                    <SparkRadioButton
                        name="CRM"
                        value={isCrmRadioButtonSelected}
                        onChange={this.handleSignInOption}
                        checked={isCrmRadioButtonSelected}
                    >
                        Open a new tab and sign in to the CRM directly
                    </SparkRadioButton>
                    {/* remove false If confition below once salesforce/barcelo feature is no longer blocked */}
                    <If condition={false}>
                        <SparkRadioButton
                            name="Salesforce"
                            value={!logInPassCredentials && integrationType === 'Salesforce'}
                            checked={!logInPassCredentials && integrationType === 'Salesforce'}
                            onChange={this.handleSignInOption}
                        >
                            Use Salesforce integration for Sign In and Enrollment
                            <br />
                            (Guest will remain on Booking Engine, SBE will host Salesforce sign-in form, and credentials
                            are managed and authenticated by Salesforce)
                        </SparkRadioButton>
                        <If
                            className="salesforce-warning"
                            condition={!logInPassCredentials && integrationType === 'Salesforce'}
                        >
                            <Message
                                heading="This option requires additional technical setup."
                                body=""
                                noBorder
                                noBackground
                                panelClassName="spark-mar-l-2 salesforce-warning-message"
                                messagePanelClassName="spark-pad-0"
                                type="warning"
                            />
                            <Link className="app-navigation-link" to="/manage/apps">
                                Go to Manage > Manage Apps > Salesforce
                            </Link>
                        </If>
                    </If>
                    <If condition={integrationType === ''}>
                        <h5>CRM Sign Up</h5>
                        <SparkRadioButton
                            name="redirect"
                            value={enrollmentFlow === 'redirect'}
                            checked={enrollmentFlow === 'redirect'}
                            onChange={() => setCustomConfigText('crm', 'enrollmentFlow', 'redirect')}
                        >
                            Open a new tab to the CRM "Create Account" form
                        </SparkRadioButton>
                        <If condition={enrollmentFlow === 'redirect'}>
                            <div className="space-bottom-small">
                                <ReactSparkTextInput
                                    label="Enter “Create Account” Form Link"
                                    isDisabled={isDisabled}
                                    value={currentConfigCopy.crm.createProfileUrl}
                                    onChange={event => {
                                        setCustomConfigText('crm', 'createProfileUrl', event.target.value);
                                    }}
                                />
                            </div>
                        </If>
                        <SparkRadioButton
                            name="useEnrollmentApi"
                            value={enrollmentFlow === 'useEnrollmentApi'}
                            onChange={() => setCustomConfigText('crm', 'enrollmentFlow', 'useEnrollmentApi')}
                            checked={enrollmentFlow === 'useEnrollmentApi'}
                        >
                            Use the Booking Engine "Create Account" form
                        </SparkRadioButton>
                    </If>
                </div>
                <If condition={integrationType === ''}>
                    <div className="indent-left-small space-bottom-small">
                        <h5>CRM Password Reset</h5>
                        <SparkRadioButton
                            name="disableResetPassword"
                            value={!currentConfigCopy.disableResetPassword}
                            checked={!currentConfigCopy.disableResetPassword}
                            onChange={() => setConfigBoolean('disableResetPassword', false)}
                        >
                            Allow password reset
                        </SparkRadioButton>
                        <If condition={!currentConfigCopy.disableResetPassword}>
                            <div className="space-bottom-small">
                                <ReactSparkTextInput
                                    label="Enter “Forgot Password” Form Link"
                                    isDisabled={isDisabled}
                                    value={currentConfigCopy.crm.forgotPasswordUrl}
                                    onChange={event => {
                                        setCustomConfigText('crm', 'forgotPasswordUrl', event.target.value);
                                    }}
                                />
                            </div>
                        </If>
                        <SparkRadioButton
                            name="disableResetPassword"
                            value={currentConfigCopy.disableResetPassword}
                            checked={currentConfigCopy.disableResetPassword}
                            onChange={() => setConfigBoolean('disableResetPassword', true)}
                        >
                            Disable password reset
                        </SparkRadioButton>
                    </div>
                    <div className="indent-left-small space-bottom">
                        <CollapsePanel
                            expanded={currentConfigCopy.isLoyaltyProgramAssignedToProvider}
                            title="GHA Profile Provider Settings - For GHA Customers ONLY"
                            spaceBetween
                        >
                            <Message
                                heading="GHA Profile Settings."
                                body="Do not use these unless you are a GHA customer."
                                noBorder
                                noBackground
                                messagePanelClassName="spark-pad-0"
                                inline
                                type="warning"
                            />
                            <div className="indent-left">
                                <ConfigurationCheckbox
                                    ref={this.registerSection(2)}
                                    style={this.sectionStyleHandler(2)}
                                    title="Use GHA Profiles as Profile Provider"
                                    code="isLoyaltyProgramAssignedToProvider"
                                    isDisabled={isDisabled}
                                    onChange={this._onUseGhaProviderCheckboxChange}
                                    value={currentConfigCopy.isLoyaltyProgramAssignedToProvider}
                                />
                                <If condition={currentConfigCopy.isLoyaltyProgramAssignedToProvider}>
                                    <div className="indent-left">
                                        <ConfigurationCheckbox
                                            ref={this.registerSection(3)}
                                            style={this.sectionStyleHandler(3)}
                                            title="Allow dual Sign In through GHA Profiles AND SynXis CR Profiles"
                                            code="offerDual"
                                            isDisabled={isDisabled}
                                            onChange={toggleConfigBoolean}
                                            value={currentConfigCopy.offerDual}
                                        />
                                        <div className="indent-left">
                                            <SparkRadioButton
                                                name="isGhaBoxChecked"
                                                value={false}
                                                checked={
                                                    currentConfigCopy.isGhaBoxChecked === 'false' ||
                                                    currentConfigCopy.isGhaBoxChecked === false
                                                }
                                                onChange={() => setConfigBoolean('isGhaBoxChecked', false)}
                                            >
                                                HS SynXis CR (CRS) is primary Profile Provider
                                            </SparkRadioButton>
                                            <SparkRadioButton
                                                name="isGhaBoxChecked"
                                                value
                                                checked={
                                                    currentConfigCopy.isGhaBoxChecked === 'true' ||
                                                    currentConfigCopy.isGhaBoxChecked === true
                                                }
                                                onChange={() => setConfigBoolean('isGhaBoxChecked', true)}
                                            >
                                                GHA Profiles is primary Profile Provider
                                            </SparkRadioButton>
                                        </div>
                                    </div>
                                </If>
                            </div>
                        </CollapsePanel>
                    </div>
                </If>
            </div>
        );
    };

    renderCrmSamlSsoSettings = () => {
        const { currentConfigCopy, setCustomConfigText } = this.props;
        return (
            <div className="crm-saml-sso-settings">
                <h5>CRM SIGN IN</h5>
                <ReactSparkTextInput
                    className="spark-mar-b-1"
                    label="Enter SAML Idp Redirection Link (Obtained from Identity Provider)"
                    value={defaultTo(get(currentConfigCopy, 'crm.idpUrl'), '')}
                    onChange={e => setCustomConfigText('crm', 'idpUrl', e.target.value)}
                />
                <ReactSparkTextInput
                    label="Enter SAML Idp ID (Obtained from Identity Provider)"
                    value={defaultTo(get(currentConfigCopy, 'crm.idpId'), '')}
                    onChange={e => setCustomConfigText('crm', 'idpId', e.target.value)}
                />
            </div>
        );
    };

    changeSignInCheckboxes = (key, value) => {
        const { setConfigBoolean, toggleConfigBoolean } = this.props;

        // if changing allowLogin from true to false, turn off configs that require allowLogin
        if (key === 'allowLogin' && value === true) {
            setConfigBoolean('allowBookOnBehalf', false);
            setConfigBoolean('crm.enabled', false);
        }

        // if you turn on either configs that require allowLogin, make sure allowLogin is true
        if ((key === 'allowBookOnBehalf' || key === 'crm.enabled') && value === false) {
            setConfigBoolean('allowLogin', true);
        }

        toggleConfigBoolean(key, value);
    };

    render() {
        const {
            currentConfigCopy,
            isDisabled,
            toggleConfigBoolean,
            setConfigText,
            addConfigRow,
            editConfigRow,
            deleteConfigRow,
            setCustomConfigText
        } = this.props;
        const { NONE, PROFILE_PROVIDER, SAML_SSO } = CRM_SIGN_IN_TYPE;
        const crmSignInType = get(currentConfigCopy, 'crm.crmSignInType');

        return (
            <div className="spark-panel__content col-lg-12">
                <h4>Global Bar Settings</h4>
                <ReactSparkTextInput
                    ref={this.registerSection(11)}
                    style={this.sectionStyleHandler(11)}
                    label="Enter web address for logo (usually hotel's home page)"
                    name="theme-name"
                    isDisabled={isDisabled}
                    value={currentConfigCopy.configURL}
                    onChange={event => {
                        setConfigText('configURL', event.target.value);
                    }}
                    onBlur={event => {
                        setConfigText('configURL', event.target.value);
                    }}
                />
                <h4 className="spark-mar-t-1">Sign In Settings</h4>
                <ConfigurationCheckbox
                    ref={this.registerSection(0)}
                    style={this.sectionStyleHandler(0)}
                    title="Allow guests to Sign In to CRM or SynXis CR Profile"
                    code="allowLogin"
                    isDisabled={isDisabled}
                    onChange={this.changeSignInCheckboxes}
                    value={currentConfigCopy.allowLogin}
                />
                <div className="indent-left">
                    <ConfigurationCheckbox
                        ref={this.registerSection(7)}
                        style={this.sectionStyleHandler(7)}
                        title="Allow booker profiles to book on behalf of guests when signed in"
                        code="allowBookOnBehalf"
                        isDisabled={isDisabled}
                        onChange={this.changeSignInCheckboxes}
                        value={currentConfigCopy.allowBookOnBehalf}
                    />
                    <h5 className="indent-left-small">CRM Settings</h5>
                    <SparkRadioButton
                        className="indent-left-small"
                        name="crm_sign_in_type_none"
                        value={NONE}
                        checked={isEqual(crmSignInType, NONE)}
                        onChange={e => setCustomConfigText('crm', 'crmSignInType', e.target.value)}
                    >
                        Allow guests to Sign In to Profile through SynXis CR (no CRM)
                    </SparkRadioButton>
                    <SparkRadioButton
                        className="indent-left-small"
                        name="crm_sign_in_type_profile_provider"
                        value={PROFILE_PROVIDER}
                        checked={isEqual(crmSignInType, PROFILE_PROVIDER)}
                        onChange={e => setCustomConfigText('crm', 'crmSignInType', e.target.value)}
                    >
                        Allow guests to Sign In to Profile through Profile Provider (CRM)
                    </SparkRadioButton>
                    <SparkRadioButton
                        className="indent-left-small"
                        name="crm_sign_in_type_saml_sso"
                        value={SAML_SSO}
                        checked={isEqual(crmSignInType, SAML_SSO)}
                        onChange={e => setCustomConfigText('crm', 'crmSignInType', e.target.value)}
                    >
                        Allow guests to Sign In to Profile through Profile Provider via SAML (CRM/IdP)
                    </SparkRadioButton>
                    <If condition={isEqual(crmSignInType, PROFILE_PROVIDER)}>
                        {this.renderCrmProfileProviderSettings()}
                    </If>
                    <If condition={isEqual(crmSignInType, SAML_SSO)}>{this.renderCrmSamlSsoSettings()}</If>
                </div>
                <section ref={this.registerSection(12)} style={this.sectionStyleHandler(12)}>
                    <h4>Loyalty Options Enabled by Sign In</h4>
                    <ConfigurationCheckbox
                        ref={this.registerSection(10)}
                        style={this.sectionStyleHandler(10)}
                        title="Show expiration message for memberships to loyalty programs"
                        code="enableMembershipExpirationMessage"
                        isDisabled={isDisabled}
                        onChange={toggleConfigBoolean}
                        value={currentConfigCopy.enableMembershipExpirationMessage}
                    />
                    <ConfigurationCheckbox
                        ref={this.registerSection(10)}
                        style={this.sectionStyleHandler(10)}
                        title="Show special member room rates even when users are not signed in; prompt users to sign in when clicked"
                        code="signInForBenefits.inUse"
                        isDisabled={isDisabled}
                        onChange={toggleConfigBoolean}
                        value={currentConfigCopy.signInForBenefits.inUse}
                    />
                    <If condition={currentConfigCopy.signInForBenefits.inUse}>
                        <div className="spark-panel__content col-lg-12">
                            <ConfigManage
                                list={currentConfigCopy.signInForBenefits.loyaltyAssignments}
                                isDisabled={isDisabled}
                                addConfigRow={addConfigRow}
                                editConfigRow={editConfigRow}
                                deleteConfigRow={deleteConfigRow}
                                columns={{
                                    programId: 'Program ID',
                                    levelCode: 'Level Code'
                                }}
                            />
                        </div>
                    </If>
                </section>
            </div>
        );
    }
}

GlobalBarConfiguration.propTypes = {
    setConfigBoolean: PropTypes.func.isRequired,
    toggleConfigBoolean: PropTypes.func.isRequired,
    addConfigRow: PropTypes.func.isRequired,
    setCustomConfigText: PropTypes.func.isRequired,
    editConfigRow: PropTypes.func.isRequired,
    deleteConfigRow: PropTypes.func.isRequired,
    currentConfigCopy: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    setConfigText: PropTypes.func.isRequired,
    searchIndex: PropTypes.array,
    onIndex: PropTypes.func
};

export default GlobalBarConfiguration;



// WEBPACK FOOTER //
// ./src/components/pages/pages/GlobalBarConfiguration.js